import React, { FC } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import { ModalHeader } from '@cps'
import i18n from 'i18next'
import './detail.scss'

interface IProps {
  extra: {
    copywriting?: string;
    participateType: string;
    participateNum: number;
    receivedNum?: number;
    everyDayReceiveNumber?: number;
  };
  reject?: () => void;
  resolve?: () => void;
}

const MarketDetail: FC<IProps> = (props: IProps) => {
  const { extra, resolve } = props
  return (
    <IonModal
      cssClass='code-coupon-detail-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={resolve}
    >
      <ModalHeader title={i18n.t('mkt.market.marketDetail')} onClose={resolve}></ModalHeader>
      <IonContent className='modal-content'>
        <div className='detail-body'>
          {extra.copywriting && (
            <div className='detail-des'>
              <div>{i18n.t('mkt.activity.introduce')}</div>
              <div className='des'>{extra.copywriting}</div>
            </div>
          )}
          <div className='detail-des'>
            <div>{i18n.t('mkt.activity.activityRules')}</div>
            <div className='info-area'>
              <div className='info-item'>
                <div className='left'>
                  {i18n.t('mkt.activity.activityCollectTimes')}:
                </div>
                <div className='right'>
                  {extra.receivedNum
                    ? i18n.t('mkt.activity.activityCollectTimesTip2', { n: extra.receivedNum })
                    : (extra.everyDayReceiveNumber ? i18n.t('mkt.activity.activityCollectTimesTip3', { n: extra.everyDayReceiveNumber }) : i18n.t('mkt.activity.activityCollectTimesTip1'))}
                </div>
              </div>
              <div className='info-item'>
                <div className='left'>
                  <div>{i18n.t('mkt.activity.personActivityCollectTimes')}</div>
                </div>
                <div className='right'>
                  {i18n.t(`mkt.activity.${extra.participateType === 'total' ? 'personActivityCollectTimesTip1' : 'personActivityCollectTimesTip2'}`, { n: extra.participateNum })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default MarketDetail
